import { render } from "./SupAadminDash.vue?vue&type=template&id=8115a3a8"
import script from "./SupAadminDash.vue?vue&type=script&lang=js"
export * from "./SupAadminDash.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__